export const getRedirect = (location, logout = false) => {
    const redirectParam = logout ? 'destURL' : 'rurl';
    return `?${redirectParam}=${encodeURIComponent(
        `${location.origin}${location.pathname}`
    )}`;
};
